import './Spacing.scss';

export interface SpacingProps {
  className?: string;
}

export function Spacing({ className = '' }: SpacingProps) {
  return <div className={`spacing ${className}`.trim()} />;
}
